import React, { useState, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import CommonLoader from "../../../vlp/components/common/CommonLoader";
import ScannerInput from "../ScannerInput";
import cloneDeep from "clone-deep";
import { CreateBatch } from "../../../services/BatchService";
import {
  Grid,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  TextField,Box, Typography,Button, IconButton
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import UserSelectorDialog from "../../../vlp/components/common/UserSelectorDialog";

const model = {
  id: 0,
  analysisType: "",
  inTime: null,
  outTime: null,
  samplesInBatch: [],
  location: "",
  inUser: "",
  reviewComment: "",
};

export default function IncubatorInBatches() {
  const [loading, setLoading] = useState(false);
  const [location, setSelectedLocationFilter] = useState("");
  const [user, setSelectedUserFilter] = useState("");
  const [samples, setSamples] = useState([]);
  const [instance, setInstance] = useState();
  const [selectedAnalyst, setSelectedAnalyst] = useState(null);
  const [userSelectorOpen, setUserSelectorOpen] = useState(false);
  // const [user, setUser] = useState("");

  useEffect(() => {
    setInstance({ ...instance, location: location });
  }, [location]);

  useEffect(() => {
    let i = cloneDeep(model);
    i.inTime = getFormattedDateTime();
    i.location = location;
    setInstance(i);
  }, []);

  const handleScan = (scan) => {
    if (!samples.find((s) => s === scan))
      setSamples((oldArry) => [...oldArry, scan]);
  };

  const removeScan = (scan) => {
    setSamples(samples.filter((i) => i !== scan));
  };

  const handleAnalystSelect = (user) => {
    
    setSelectedAnalyst(user);
    setInstance({ ...instance, inUser: user.operator });
    setSelectedUserFilter(user.operator);
  };

  const handleSubmit = async () => {
    let submissionModel = instance;
    submissionModel.inUser = user;

    if (!submissionModel.location || submissionModel.location === "") {
      NotificationManager.error("Location is not set", "Error Submitting");
      return;
    }

    samples.map((item) => {
      if (submissionModel.analysisType.indexOf("HPC") === -1) {
        submissionModel.samplesInBatch.push({
          sampleLabId: item,
          ecoli: false,
          coliform: false,
          reviewComment: submissionModel.reviewComment,
        });
      } else {
        submissionModel.samplesInBatch.push({
          sampleLabId: item,
          reviewComment: submissionModel.reviewComment,
        });
      }
    });

    try {
      let response = await CreateBatch(submissionModel);

      let i = cloneDeep(model);
      i.inTime = getFormattedDateTime();
      // i.location = location;
      setInstance(i);
      setSamples([]);
      setSelectedLocationFilter(null);
      setSelectedUserFilter(null);
      NotificationManager.success("Batch created");
      window.location.reload();
    } catch (err) {
      NotificationManager.error(err.toString(), "Error Submitting");
    }
  };


  const handleLocationChange = (event) => {
    setSelectedLocationFilter(event.target.value);
  };

  // Static locations list
  const locations = [
    "Madison 1",
    "Madison 2",
    "Madison 3",
  ];
  const getFormattedDateTime = (value) => {
    const date = value ? new Date(value) : new Date();

    const pad = (n) => String(n).padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <div className="vlp-component-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span className="title">MicroManage IN</span>
      </div>
      <hr />

      <Grid container spacing={2} sx={{ marginBottom: 2 }}>
        {/* Analysis Type */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="analysis-type-label">Analysis Type</InputLabel>
            <Select
              labelId="analysis-type-label"
              value={instance?.analysisType || ""}
              onChange={(e) =>
                setInstance({ ...instance, analysisType: e.target.value })
              }
              label="Analysis Type"
            >
              <MenuItem value="">
                <em>Select analysis type</em>
              </MenuItem>
              <MenuItem value="HPC">HPC (Pool)</MenuItem>
              <MenuItem value="TCDW">TC (DW)</MenuItem>
              <MenuItem value="TCPOOL">TC (Pool)</MenuItem>
              <MenuItem value="Ecoli">E.coli</MenuItem>
              <MenuItem value="HPCDW">HPC (DW)</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* Location */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="select-location-label">Select location</InputLabel>
            <Select
              labelId="select-location-label"
              value={instance?.location}
              onChange={handleLocationChange}
              label="Select location"
            >
              <MenuItem value="">
                <em>Select location</em>
              </MenuItem>
              {locations
                .sort((a, b) => a.localeCompare(b))
                .map((location) => (
                  <MenuItem key={location} value={location}>
                    {location}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>

        {/* In User */}
         <Grid item xs={12} sm={6} md={4} lg={3}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {selectedAnalyst ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1,
                      border: 1,
                      borderColor: "grey.300",
                      borderRadius: 1,
                      backgroundColor: "grey.50",
                      minHeight: "40px",
                    }}
                  >
                    <Box sx={{ flexGrow: 1 }} size="small">
                      <Typography variant="body2" fontWeight="medium" size="small">
                        {selectedAnalyst.operator} - {selectedAnalyst.aliasName}
                      </Typography>
                    </Box>
                    <IconButton
                      size="small"
                      onClick={() => setUserSelectorOpen(true)}
                      sx={{ color: "primary.main", ml: 1 }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ) : (
                  <Button
                    variant="outlined"
                    startIcon={<PersonIcon />}
                    size="small"
                    onClick={() => setUserSelectorOpen(true)}
                    sx={{
                      justifyContent: "flex-start",
                      textTransform: "none",
                      height: "40px",
                    }}
                  >
                    Select Analyst
                  </Button>
                )}
              </Box>
            </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="In Time"
            type="datetime-local"
            InputLabelProps={{
              shrink: true,
            }}
            value={instance?.inTime}
            onChange={(e) =>
              setInstance({
                ...instance,
                inTime: getFormattedDateTime(e.target.value),
              })
            }
            size="small"
          />
        </Grid>

        {/* Batch Comments */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="Batch Comments"
            type="text"
            placeholder="Batch Comments"
            inputProps={{ maxLength: 200 }}
            value={instance?.reviewComment}
            onChange={(e) =>
              setInstance({ ...instance, reviewComment: e.target.value })
            }
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <ScannerInput onScanComplete={handleScan} />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <button
            className="button is-primary"
            disabled={
              !samples ||
              samples.length === 0 ||
              !instance?.inTime ||
              !instance?.location ||
              !instance?.analysisType ||
              !instance?.inUser
            }
            onClick={handleSubmit}
          >
            Submit
          </button>
        </Grid>
      </Grid>

      <div>
        <div sx={{ width: "100%" }}>
          <>
            {samples.length !== 0 && (
              <div className="columns">
                <div className="column is-4">
                  <table className="table is-striped is-fullwidth">
                    <thead>
                      <tr>
                        <td className="is-bold">
                          New Batch - {samples.length} samples{" "}
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {samples
                        .sort(function compare(a, b) {
                          try {
                            var aSections = a.split("-");
                            var bSections = b.split("-");
                            if (aSections?.length > 1) {
                              if (aSections[0] > bSections[0]) {
                                return 1;
                              } else if (aSections[0] == bSections[0]) {
                                if (
                                  parseInt(aSections[1]) >
                                  parseInt(bSections[1])
                                )
                                  return 1;
                                else return -1;
                              } else {
                                return -1;
                              }
                            }

                            return 1;
                          } catch (err) {
                            console.log(err);
                            return 0;
                          }
                        })
                        .map((item) => (
                          <tr key={item}>
                            <td>
                              <span>{item}</span>
                            </td>
                            <td className="has-text-right">
                              <button
                                className="button is-small is-rounded is-danger is-bold"
                                onClick={() => removeScan(item)}
                              >
                                X
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* <hr /> */}
          </>
        </div>
      </div>

      <CommonLoader loading={loading} />
      <UserSelectorDialog
        open={userSelectorOpen}
        onClose={() => setUserSelectorOpen(false)}
        onSelect={handleAnalystSelect}
        multiSelect={false}
        filter="ANALYSTS"
      />

    </div>
  );
}
